import { useCallback, useRef, useState } from 'react';

const isEyeDropperSupported = typeof window !== 'undefined' && 'EyeDropper' in window;

export const useEyeDropper = () => {
  const [isActive, setIsActive] = useState(false);
  const abortControllerRef = useRef(null);

  const pickColor = useCallback(async () => {
    if (!isEyeDropperSupported) return null;

    abortControllerRef.current?.abort();
    const controller = new AbortController();
    abortControllerRef.current = controller;

    setIsActive(true);
    try {
      const dropper = new window.EyeDropper();
      const result = await dropper.open({ signal: controller.signal });
      return result.sRGBHex;
    } catch {
      return null;
    } finally {
      setIsActive(false);
      abortControllerRef.current = null;
    }
  }, []);

  const cancel = useCallback(() => {
    abortControllerRef.current?.abort();
  }, []);

  return { isSupported: isEyeDropperSupported, isActive, pickColor, cancel };
};
